const CI_COMMIT_REF_NAME = "trunk";
const CI_COMMIT_SHA = "37e9b3654cda7248dcafdd2530064bf3e2f1aec4";
const CI_COMMIT_SHORT_SHA = "37e9b365";
const INTEGRATES_BUCKET_NAME = "views2.fluidattacks.com";

export {
  CI_COMMIT_REF_NAME,
  CI_COMMIT_SHA,
  CI_COMMIT_SHORT_SHA,
  INTEGRATES_BUCKET_NAME,
};
